export default __webpack_public_path__ + "static/media/controller.2e22d7d4.png";